<template>
  <div>
    <v-autocomplete
      v-bind:label="label"
      data-lpignore="true"
      hide-details="auto"
      v-bind:item-text="itemText"
      v-bind:item-value="itemValue"
      v-bind:multiple="multiple"
      v-bind:clearable="clearable"
      :menu-props="menuProps"
      name="category"
      v-bind:items="items"
      v-bind:loading="loading"
      v-bind:hide-no-data="loading"
      v-on="$listeners"
      v-bind="$attrs">
      <template v-slot:append-item>
        <button
          class="custom-item"
          type="button"
          v-on:click="handleCustomItemClick"
          v-if="isShowCustomItem"
        >
          {{ customItem[itemText] }}
        </button>
      </template>
      <template v-slot:no-data>
        <slot name="no-data">
          <p class="no-data">Результатов нет</p>
        </slot>
      </template>
    </v-autocomplete>
    <p
      class="text__violation"
      role="alert"
      v-for="error in violations"
      v-bind:key="error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AutocompleteInput',
  computed: {
    /**
     * Показывать ли особый компонент
     *
     * @return {{bool}}
     */
    isShowCustomItem() {
      return this.customItem !== null;
    },
  },
  methods: {
    /**
     * @description Прослушивать событие клика на кастомном элементе.
     * @returns {void}
     */
    handleCustomItemClick() {
      this.$emit('custom-item-click');
    },
  },
  props: {
    label: {
      default: () => '',
      type: String,
    },
    itemValue: {
      default: () => 'value',
      type: String,
    },
    itemText: {
      default: () => 'text',
      type: String,
    },
    items: {
      required: true,
      type: Array,
    },
    /**
     * @description Ошибки.
     */
    violations: {
      default: () => [],
      type: Array,
    },
    multiple: {
      default: () => false,
      type: Boolean,
    },
    menuProps: {
      default: () => {},
      type: Object,
    },
    clearable: {
      default: () => false,
      type: Boolean,
    },
    customItem: {
      default: null,
      type: Object,
    },
    loading: { default: false, type: Boolean },
  },
};
</script>

<style lang="scss" scoped>
  .custom-item {
    padding-inline: 16px;
    padding-block: 12px;
    text-align: left;
  }
  .no-data {
    padding: 10px;
    margin: 0;
  }
  .multiline::v-deep .v-list-item__title {
    white-space: normal !important;
  }
  ::v-deep .v-text-field--outlined .v-input__icon {
    .mdi-menu-down::before {
      content: "";
      width: 14px;
      height: 8px;
      background: url("@/assets/img/checked/checked-grey.svg") 50%;
      background-size: contain;
      cursor: pointer;
    }
  }
  .text-small {
    .v-list {
      ::v-deep .v-list-item {
        min-height: 44px;
        &__content {
          padding-block: 10px;
        }
        &__title {
          font-size: 14px !important;
        }
      }
    }
  }
  .text-big {
    .v-list {
      ::v-deep .v-list-item {
        min-height: 44px;
        &__content {
          padding-block: 12px;
        }
        &__title {
          font-size: 16px !important;
          font-weight: 400;
        }
      }
    }
  }
  .text__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: 0.125rem;
  }
</style>
